import { TPortfolioCompany } from "../../const/const";
import styles from "./TableBody.module.scss";
import { Checkbox } from "@/frontend/shared/ui/Checkbox";
import { buildCells } from "../RowCell/RowCell";
import { DeleteCompanyModal } from "@/frontend/features/Company/ui/DeleteCompany/DeleteCompanyModal/DeleteCompanyModal";
import { MoveModal } from "@/frontend/features/Company/ui/MoveCompany/MoveModal/MoveModal";
import { Dispatch, SetStateAction, useState } from "react";
import { Loader } from "@/frontend/shared/ui/Loader/Loader";
import { Pagination } from "@/frontend/shared/ui/Pagination/Pagination";
import { AddTagsModal } from "@/frontend/components/AddTagsModal/ui/AddTagsModal";
import { useHistoricalNavigate } from "@/frontend/shared/lib/useHistoricalNavigate/useHistoricalNavigate";
import { getRoutePortfolioCompanyProfile } from "@/frontend/shared/const/router";
import { SkeletonCompanyRow } from "@/frontend/shared/ui/SkeletonCompanyRow/SkeletonCompanyRow";
import { Typography } from "@/frontend/shared/ui/Typography";
import { HorizontalLines } from "@/frontend/shared/assets/icons";
import { EDataStatus } from "@/frontend/features/Company/model/types/types";

type TTableBody = {
  selected: number[];
  onChange: (id: number) => void;
  data: { portfolioCompanies: TPortfolioCompany[]; totalPortfolioCompanies: number };
  triggerRefetch: () => void;
  // companyHeaders: { value: string; label: string }[];
  limit: number;
  setPage: Dispatch<SetStateAction<number>>;
  currentPage: number;
  isLoading: boolean;
};

export function TableBody({
  selected,
  onChange,
  data,
  triggerRefetch,
  // companyHeaders,
  setPage,
  limit,
  currentPage,
  isLoading
}: TTableBody) {
  const [shownModal, setShownModal] = useState<{ type: string; id: number }>({ type: "", id: -1 });
  const [selectedOption, setSelectedOption] = useState<string>("");
  const { navigate } = useHistoricalNavigate();

  const tableData = data?.portfolioCompanies || data;

  // function getStageIdByName(name: string) {
  //   const stageName = companyHeaders?.find((stage) => stage.label === name);
  //   return Number(stageName?.value);
  // }

  function getCurrentTagsById(id: number) {
    const company = data?.portfolioCompanies.find((company) => company.id === id);
    return company ? company.tags.map((tag) => tag.name) : [];
  }

  if (isLoading) {
    return (
      <div className={styles.loaderContainer}>
        <Loader />
      </div>
    );
  }

  if (tableData.length === 0) {
    return (
      <div className={styles.emptyPageContainer}>
        <div className={styles.emptyContainer}>
          {/* <Typography variant="heading-7" color="greyscale800">
            No archived companies yet
          </Typography>
          <Typography variant="body-2" color="greyscale800">
            Archived companies will be manageable here
          </Typography> */}
          <HorizontalLines className={styles.horizontalLines} />
          <Typography variant="heading-6" color="greyscale800">
            Archive empty
          </Typography>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className={styles.cardContainer}>
        {tableData?.map((portfolioCompany, index) => {
          return portfolioCompany.parsingStatus === EDataStatus.done ||
            portfolioCompany.parsingStatus === EDataStatus.matching_done ? (
            <div
              key={index}
              className={styles.card}
              onClick={() => navigate(getRoutePortfolioCompanyProfile(portfolioCompany.id))}
            >
              <div className={styles.checkboxContainer}>
                <Checkbox
                  value={selected.includes(portfolioCompany.id)}
                  onChange={() => {
                    onChange(portfolioCompany.id);
                  }}
                  className={styles.checkbox}
                />
              </div>
              {buildCells(portfolioCompany, selected, setShownModal)}
            </div>
          ) : (
            <SkeletonCompanyRow />
          );
        })}
      </div>
      <div className={styles.paginationContainer}>
        <Pagination
          setPage={setPage}
          companiesLimit={limit}
          currentPage={currentPage}
          companiesTotal={data.totalPortfolioCompanies}
          className={styles.pagination}
          isLoading={isLoading}
        />
      </div>
      <DeleteCompanyModal
        isOpen={shownModal.type === "delete"}
        onClose={() => setShownModal({ type: "", id: -1 })}
        id={shownModal.id}
        triggerRefetch={triggerRefetch}
      />
      {/* <MoveModal
        isOpen={shownModal.type === "move"}
        onClose={() => setShownModal({ type: "", id: -1 })}
        companyIds={selected?.length ? selected : [shownModal.id]}
        stageId={getStageIdByName(selectedOption) || 0}
        triggerRefetch={triggerRefetch}
        options={companyHeaders}
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
      /> */}
      <AddTagsModal
        isOpen={shownModal.type === "addTags"}
        ids={[shownModal.id]}
        onClose={() => setShownModal({ type: "", id: -1 })}
        triggerRefetch={triggerRefetch}
        currentTags={getCurrentTagsById(shownModal.id)}
        tagsWithIdsData={[]}
      />
    </>
  );
}
